import PrimaryButton from "../../../Components/Buttons/primary-button";

import { useConsumerDealsData } from "../../../Pages/Deals";

import { useModalContext } from "../../../Contexts/ModalContext";

import { modalVariants } from "../../../Utils/constants";

import { PersonWithKeyIllustration } from "../../../Assets/Images";

export default function renderStakeSaverSetupSuccess(modalContext) {
  const { updateModalComponent, setModalVariant, setModalClassName, setModalAriaLabel } = modalContext;

  updateModalComponent(StakeSaverSetupSuccess);
  setModalVariant(modalVariants.flexDialog);
  setModalClassName("hide-header");
  setModalAriaLabel?.("Stake Saver setup complete");
}

export const StakeSaverSetupSuccess = () => {
  const { onModalClose } = useModalContext();
 
  const { stakeSaverOffer } = useConsumerDealsData();

  return (
    <><img className="modal-image person-with-key-illustration" src={PersonWithKeyIllustration} alt="" />
      <div className="modal-dialog-content mt-6">
        <h3 className="modal-status-title mb-0">You’re in! Here’s what’s live:</h3>
        <div className="numbered-list mt-4">
          {stakeSaverOffer?.offer_details?.learn_more_items?.map((benefit, idx) => (
            <div key={idx} className="list-item">
              <span className="list-item-badge">✅</span>
              <div className="list-item-content">
                <p className="text-lg-medium color--mist mb-0">{benefit}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="action-container split-equally">
        <PrimaryButton onClick={onModalClose}>Done</PrimaryButton>
      </div>
    </>
  );
};
